module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_02 (1).8450b22c.png";